(function () {
  if (window.__socialSharingInit) return;
  window.__socialSharingInit = true;

  function showToast(triggerEl, message) {
    if (!message) return;
    var wrapper = triggerEl.closest('.social_share_links_wrapper');
    var toast = wrapper && wrapper.querySelector('[data-share-toast]');
    if (!toast) return;

    toast.textContent = message;
    toast.hidden = false;

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    clearTimeout(toast._hideTimeout);
    toast._hideTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
      }, 250);
    }, 2200);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '0';
        input.style.left = '0';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.focus();
        input.select();
        input.setSelectionRange(0, text.length);

        var successful = document.execCommand('copy');
        document.body.removeChild(input);

        if (successful) {
          resolve();
        } else {
          reject(new Error('execCommand copy failed'));
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function openWeb(webUrl) {
    window.open(webUrl, '_blank', 'noopener,noreferrer');
  }

  document.addEventListener('click', function (event) {
    var copyBtn = event.target.closest('[data-copy-link]');
    if (copyBtn) {
      var copyUrl = copyBtn.getAttribute('data-share-url');
      copyText(copyUrl)
        .then(function () {
          showToast(copyBtn, copyBtn.getAttribute('data-copied-message'));
        })
        .catch(function () {
          showToast(copyBtn, copyBtn.getAttribute('data-copy-failed-message'));
        });
      return;
    }

    var appBtn = event.target.closest('[data-share-app]');
    if (appBtn) {
      var app = appBtn.getAttribute('data-share-app');
      var shareUrl = appBtn.getAttribute('data-share-url');

      copyText(shareUrl)
        .then(function () {
          showToast(appBtn, appBtn.getAttribute('data-copied-message'));
        })
        .catch(function () {
          // Clipboard copy failed silently; still proceed to open the site below.
        });

      if (app === 'instagram') {
        openWeb('https://www.instagram.com/');
      } else if (app === 'tiktok') {
        openWeb('https://www.tiktok.com/');
      }
    }
  });
})();
